// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreatePaymentPlanDTO
 */
export interface CreatePaymentPlanDTO {
    /**
     * 
     * @type {string}
     * @memberof CreatePaymentPlanDTO
     */
    orderCustomerId: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePaymentPlanDTO
     */
    startDate: string;
    /**
     * 
     * @type {number}
     * @memberof CreatePaymentPlanDTO
     */
    amountPerInstalment: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePaymentPlanDTO
     */
    manualPaymentsTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePaymentPlanDTO
     */
    interestAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePaymentPlanDTO
     */
    isHistoric: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatePaymentPlanDTO
     */
    productType?: CreatePaymentPlanDTOProductTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CreatePaymentPlanDTOProductTypeEnum {
    CUSTOM = 'CUSTOM',
    PAYIN3 = 'PAY_IN_3',
    PAYLATER = 'PAY_LATER'
}



